import { render, staticRenderFns } from "./setOtpauthMigrationToDict.vue?vue&type=template&id=33dd3c5f"
import script from "./setOtpauthMigrationToDict.vue?vue&type=script&lang=js"
export * from "./setOtpauthMigrationToDict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports